import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { FAQ as FAQRouteConstants } from '../../route-constants';
import './faq-topic-toc.less';

/**
 * Helper to render FAQ Question
 * Checks for empty FAQ Questions because invalid Contentful objects.
 * @param {Object} question FAQ Question
 * @param {String} sectionSlug Slug for section
 * @returns {Node}
 */
const FAQOverviewSectionQuestion = (question, sectionSlug) => {
  if (!question.slug) {
    return null;
  }
  return (
    <li key={question.slug} className='list-item'>
      <Link
        href={`${FAQRouteConstants.BASE_URI}/[topic]`}
        as={`${sectionSlug}#${question.slug}`}>
        {question.question}
      </Link>
    </li>
  );
};

/**
 * Table of Contents for an FAQ section.
 * @returns {Node}
 */
const FAQTopicTOC = ({ title, slug, questions }) => {
  const sectionSlug = `${FAQRouteConstants.BASE_URI}/${slug}`;
  let sectionTitle = null;
  if (title) {
    sectionTitle = <h2 className='title'>{title}</h2>;
  }
  return (
    <div key={slug} className='FAQTopicTOC'>
      {sectionTitle}
      <ul className='list'>
        {questions.map((question) => FAQOverviewSectionQuestion(question, sectionSlug))}
      </ul>
    </div>
  );
};

FAQTopicTOC.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  questions: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    question: PropTypes.string,
  })),
};

FAQTopicTOC.defaultProps = {
  title: '',
  slug: '',
  questions: [],
};

export default FAQTopicTOC;
